import { c as _c } from "react/compiler-runtime";
interface AdditionalActionPromiseBadgeProps {
  readonly className?: string | undefined;
}
export function AdditionalActionPromiseBadge(t0) {
  const $ = _c(2);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `tw-inline-flex tw-shrink-0 tw-items-center tw-rounded-full tw-bg-amber-400/10 tw-px-2 tw-py-0.5 tw-text-[11px] tw-font-semibold tw-leading-5 tw-text-amber-300 tw-ring-1 tw-ring-amber-300/25 ${className}`;
  let t3;
  if ($[0] !== t2) {
    t3 = <span className={t2}>Additional Action</span>;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  return t3;
}